const MILLISECONDS_IN_SECOND = 1000;

type DecodedJwtPayload = {
  exp?: number;
};

export function decodeTokenExpiryFromJwt(token?: string): number | undefined {
  if (!token) {
    return undefined;
  }

  const tokenParts = token.split('.');
  if (tokenParts.length < 2) {
    return undefined;
  }

  try {
    const normalizedPayload = tokenParts[1]
      .replaceAll('-', '+')
      .replaceAll('_', '/')
      .padEnd(Math.ceil(tokenParts[1].length / 4) * 4, '=');
    const payload = JSON.parse(atob(normalizedPayload)) as DecodedJwtPayload;
    if (typeof payload.exp !== 'number') {
      return undefined;
    }

    return new Date(payload.exp * MILLISECONDS_IN_SECOND).getTime();
  } catch {
    return undefined;
  }
}
